<app-dialog-container>
    <h2 mat-dialog-title>{{ data.signature ? 'Editar' : 'Adicionar' }} Assinatura</h2>
    
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div mat-dialog-content fxLayout="column" fxLayoutGap="20px">
        <app-input [config]="getFieldConfig('name')" [typeCes]="typeCes" [group]="form"></app-input>
        <app-input [config]="getFieldConfig('email')" [typeCes]="typeCes" [group]="form"></app-input>
        <app-input [config]="getFieldConfig('type')" [typeCes]="typeCes" [group]="form"></app-input>
        <app-input [config]="getFieldConfig('document')" [typeCes]="typeCes" [group]="form"></app-input>
        <app-input [config]="getFieldConfig('whatsAppNumber')" [typeCes]="typeCes" [group]="form"></app-input>
      </div>

      <div mat-dialog-actions align="end">
        <button mat-button type="button" (click)="close()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">
          {{ data.signature ? 'Atualizar' : 'Adicionar' }}
        </button>
      </div>
    </form>
</app-dialog-container>